// extracted by mini-css-extract-plugin
export var cancelButton = "_oj-5";
export var content = "_oj-3";
export var createButton = "_oj-6";
export var drawerContainer = "_oj-0";
export var footer = "_oj-2";
export var header = "_oj-1";
export var orderFormColumn = "_oj-4";